import { render, staticRenderFns } from "./PdnProfileList.vue?vue&type=template&id=3698e664&"
import script from "./PdnProfileList.vue?vue&type=script&lang=js&"
export * from "./PdnProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports